import 'babel-polyfill'
import Vue from "vue";
import App from "./App.vue";
import VueRouter from "vue-router";
import router from "./routes";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import VueSweetalert2 from 'vue-sweetalert2';  
Vue.use(VueSweetalert2);  
Vue.config.productionTip = false
import AOS from 'aos'
import 'aos/dist/aos.css'
//import axios from "axios";
//import AOS from 'aos'
import 'aos/dist/aos.css'
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import * as rules from 'vee-validate/dist/rules';
import VueComp from '@vue/composition-api';
Vue.config.productionTip = false;

Vue.use(VueComp);
// install rules
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

Vue.component('ValidationObserver', ValidationObserver);
Vue.component('ValidationProvider', ValidationProvider);
import { localize } from 'vee-validate';

localize({
  en: {
    messages: {
      required: 'this field is required',
      alpha_spaces: 'this field is alphabet',
      email: 'this field is input @',
      min: 'this field must have no less than {length} characters',
      max: (_, { length }) => `this field must have no more than ${length} characters`
    }
  }
});
AOS.init({
  duration: 1200,
})
// Install BootstrapVue
Vue.use(BootstrapVue);
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin);
Vue.use(VueRouter);
Vue.config.productionTip = false

new Vue({
    data() {
        return {
          loginFormShow:false,
          changeColor:false,
          navClickHook: null,
        };
      },
  mounted () {
   
      },

    methods:{
      globalClick(event) {
        //Global Click Handler
        //console.log("Global Click Found");
       // console.log(event)
        if(this.navClickHook != null){
          this.navClickHook.globalClick(event);
        }
      }
    },
  router,
  
  render: h => h(App)
}).$mount("#app");